import { useRef, useState } from "react";
import { Alert, Button } from "@mui/material";
import { boundaryAcres, boundaryRings, parseBoundaryFile } from "../utils/fieldBoundaryGeometry";

export default function FieldBoundaryImport({ onImport, disabled = false, inputRef, toolbarReady = false }) {
  const [error, setError] = useState("");
  const [summary, setSummary] = useState("");
  const localInputRef = useRef(null);
  const fileInputRef = inputRef || localInputRef;
  return <>
      <input ref={fileInputRef} hidden type="file" accept=".geojson,.json,.kml" aria-label="Import boundary file" disabled={disabled} onChange={async (event) => {
        const file = event.target.files?.[0];
        event.target.value = "";
        if (!file) return;
        try {
          if (file.size > 5 * 1024 * 1024) throw new Error("Use a boundary file smaller than 5 MB.");
          const boundaries = parseBoundaryFile(await file.text(), file.name);
          const rings = boundaryRings(boundaries);
          onImport({ boundaries, has_boundaries: true, field_boundaries_size: boundaryAcres(boundaries) });
          setSummary(`Imported ${rings.filter((ring) => ring.ring === 0).length} piece(s) and ${rings.filter((ring) => ring.ring > 0).length} exclusion(s). Review and save the field to keep them.`);
          setError("");
        } catch (error) { setSummary(""); setError(error.message || "We could not read this boundary file."); }
      }} />
    <div className={toolbarReady ? "my-3 md:hidden" : "my-3"}>
      <Button onClick={() => fileInputRef.current?.click()} disabled={disabled}>Import boundary</Button>
    </div>
    {summary || error ? <div className="my-3 space-y-2">
    {summary ? <p role="status" className="text-sm text-slate-600">{summary}</p> : null}
    {error ? <Alert severity="error">{error}</Alert> : null}
    </div> : null}
  </>;
}
